import script from "./DbInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./DbInput.vue?vue&type=script&setup=true&lang=ts"

import "./DbInput.vue?vue&type=style&index=0&id=154e5daf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-154e5daf"]])

export default __exports__